import styled from "styled-components/macro";
import TULUIcon from "../../images/PDF/logoblack.png";
import { device } from "../device";

const BigTitle = styled.div`
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  font-family: Lexend;
  letter-spacing: normal;
  text-align: center;
  color: #000;
  margin-top: 379px;
  text-transform: uppercase;
`;

const Divider = styled.div`
  width: 90%;
  margin: 0px 5%;
  position: absolute;
  bottom: 280px;
  border-top: 2px solid black;
  height: 1px;
`;
export default function Farewell() {
  return (
    <div style={{ display: "block", textAlign: "center" }}>
      <BigTitle>LOOK FORWARD TO HEARING FROM YOU</BigTitle>
      <Divider></Divider>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "87%",
          position: "absolute",
          bottom: 100,
          left: 120,
        }}
      >
        {" "}
        <div>
          <img
            style={{ position: "relative", marginRight: 48 }}
            src={TULUIcon}
            width="270"
            height="80"
            alt="TULU"
          />
          <div style={{ fontSize: 25, display: "flex", gap: 16 }}></div>
        </div>
        <div style={{ display: "flex", gap: 16 }}>
          <City>US</City>
          <BrandItem>
            27 West 20 Street, New York, NY <br />
            sales@tulu.io
          </BrandItem>
        </div>
        <div style={{ display: "flex", gap: 16 }}>
          <City>EU</City>
          <BrandItem>
            85-87 Bayham Street, London, UK <br />
            peter@tulu.io
          </BrandItem>
        </div>
      </div>
    </div>
  );
}

const City = styled.span`
  font-family: "Lexend";
  font-weight: bold;
  @media ${device.mobileS} {
    font-size: 20px;
  }
  @media ${device.tablet} {
    font-size: 85px;
  }
`;

const BrandItem = styled.div`
  font-size: 24px;
  position: relative;
  top: 6px;
  margin-top: 20px;
  font-family: DMSans;
  text-align: left;
`;
